/* eslint-disable */
import * as React from 'react';

import AppPage from '@/ui/AppPage/AppPage';
import Box from '@mui/material/Box';
import Permissions from '@/lib/permissions';
import AppLogsTable from './AppLogsTable';

function AppLogsPage() {
  return (
    <AppPage
      titlett="admin:page.app_logs"
      needPermission={[Permissions.Administration]}
    >
      <Box m={0} style={{ height: '100%' }}>
        <AppLogsTable />
      </Box>
    </AppPage>
  );
}

export default AppLogsPage;
